import { login } from "@/services/login.svc" 

const defaultState = () => ({
  userType: location.href.indexOf('localhost') > 0 ? 'Dev' : '',
})

export default {
  namespaced: true,
  state: defaultState(),

  actions: {
    async login({ commit }, pwd) {
      const type = await login(pwd)
      commit('SET_TYPE', type)
    },

    async logout({ commit }) {
      commit('SET_TYPE', '')
    },

    setUserType({ commit }, type) {
      commit('SET_TYPE', type)
    }
  },

  getters: {
    isLoggedIn: (state) => state.userType.length > 0,
    isAdmin: (state) => ['Dev', 'Admin'].includes(state.userType),
    userType: (state) => state.userType
  },

  mutations: {
    SET_TYPE(state, payload) {
      state.userType = payload
    }
  }
}